import qs from 'query-string';
import { useLocation } from 'react-router';
import { ELanguageCodes } from 'static/config/language/languageConfig';
import { Localization } from 'static/localization/localization';

export const useViewMapQueryParams = () => {
    const location = useLocation();
    const params = qs.parse(location.search) as {
        header?: string;
        interactivityType?: string;
        disableSimpleGestures?: string;
        lang?: string;
    };

    const showHeader = params.header === '1';
    const disableSimpleGestures = params.disableSimpleGestures === '1';

    const getInteractivityType = () => {
        const value = params.interactivityType;

        if (!value) return;
        if (value === 'panel') return 'Style1' as const;
        if (value === 'popup') return 'Mini' as const;
        if (value === 'bubble') return 'Bubble' as const;
    };

    const getLanguage = () => {
        const value = params.lang;

        const validLanguages = Object.keys(ELanguageCodes);

        if (validLanguages.includes(value)) {
            return value;
        }

        return Localization.getLanguage();
    };

    return {
        showHeader,
        disableSimpleGestures,
        language: getLanguage(),
        interactivityType: getInteractivityType()
    };
};
